import angular from 'angular';
import roles from 'app/validators/roles';
import changePrimaryUserTemplate from './change-primary-user.html';

@Inject('$state', 'gettextCatalog')
class ChangePrimaryUserController {
  constructor() {
    this.initlizeConfiguration();
  }

  initlizeConfiguration() {
    this.retailerId = this.$state.params.retailerId;
    this.primaryUserId = this.$state.params.primaryUserId;
    this.noDataText = this.gettextCatalog.getString('No Secondary Users for the Retailer.');
    this.headers = this.getHeaders();
  }

  $onInit() {
    this.api.applyFilters.run({ retailerNo: this.retailerId, userClass: roles.SECONDARY_USER_ROLES, statusCode: 'ACTIVE' });
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'name',
        sortable: false,
      },
      {
        text: this.gettextCatalog.getString('Email'),
        field: 'email',
        sortable: false,
      },
      {
        text: this.gettextCatalog.getString('Available Actions'),
        field: 'actions',
        sortable: false,
        textAlignment: 'text-right'
      },
    ];
  }

  canBePromotedToPrimary(user) {
    return this.api.promoteToPrimary.hasAccess && roles.SECONDARY_USER_ROLES.indexOf(user.userClass) > -1 && user.id !== this.primaryUserId;
  }

  onPromoteToPrimary(user) {
    const promotedId = user.id;
    this.api.promoteToPrimary
      .run(promotedId, this.primaryUserId)
      .then(() => this.api.showAlert(this.gettextCatalog.getString('Success!'), this.gettextCatalog.getString('The user has been set as primary successfully.')))
      .then(() => this.onCancel());
  }

  onCancel() {
    this.$state.go('user-viewAccountDetails', { id: this.primaryUserId });
  }
}

class ChangePrimaryUserComponent {
  constructor() {
    this.template = changePrimaryUserTemplate;
    this.controller = ChangePrimaryUserController;
    this.bindings = {
      model: '<',
      api: '<',
    };
    return this;
  }
}

export default angular.module('change-primary-user', []).component('changePrimaryUser', new ChangePrimaryUserComponent());



// WEBPACK FOOTER //
// ./src/modules/user/components/change-primary-user/change-primary-user-component.js